import React from 'react';
import { useForm } from 'react-hook-form';
import { Modal } from '../../../CommonComponents/OPL/Modal/Modal';
import { ModalHeader } from '../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalBody } from '../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { Checkbox } from '../../../CommonComponents/OPL/Checkbox/Checkbox';

const HEADER_ID = 'pdf--edit-pld-modal--header';
const FORM_ID = 'pdf--edit-pld-modal--form';

interface FormValues {
  showFullBreakdown: boolean;
}

interface Props {
  data: {
    showFullBreakdown: boolean;
  };
  onSave(showFullBreakdown: boolean): void;
  onClose(): void;
}

export const AssetBucketing = ({ data, onSave, onClose }: Props) => {
  const { handleSubmit, register } = useForm<FormValues>({
    defaultValues: {
      showFullBreakdown: data.showFullBreakdown,
    },
  });

  const onSubmit = handleSubmit(values => {
    onSave(values.showFullBreakdown);
    onClose();
  });

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      aria={{ labelledby: HEADER_ID }}
      shouldCloseOnOverlayClick={false}
    >
      <ModalHeader as="h2" id={HEADER_ID}>
        Edit Asset Bucketing
      </ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalBody id={FORM_ID} as="form" onSubmit={onSubmit}>
        <Checkbox {...register('showFullBreakdown')}>
          Show asset bucketing full breakdown in the template
        </Checkbox>
      </ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button type="submit" form={FORM_ID} ml="8">
          Save Changes
        </Button>
      </ModalFooter>
    </Modal>
  );
};
